import React from 'react'
import './Nav.css'
import { Link } from 'react-router-dom'
import Logo from './Logo'


const Nav = (props) => {

const isDesktop = props.isDesktop;

const nav = props.nav;

const setNav = props.setNav;

    return (

    <nav className={isDesktop ? "navBar" : "navMobile"}>
        
    {isDesktop ? <Logo isDesktop={isDesktop} /> : ''}


   <Link to="/" className='navLinks' onClick={() => {if(isDesktop) {} else {setNav(!nav)}}}>Home</Link>
      <Link to="/about" className="navLinks" onClick={() => {if(isDesktop) {} else {setNav(!nav)}}}>About</Link>
    <Link to="/services" className="navLinks" onClick={() => {if(isDesktop) {} else {setNav(!nav)}}}>Services</Link>
    <Link to="/news" className="navLinks" onClick={() => {if(isDesktop) {} else {setNav(!nav)}}}>News</Link>
  <Link to="/contact" className="navLinks" onClick={() => {if(isDesktop) {} else {setNav(!nav)}}}>Contact</Link>

 

</nav>


    )
}

export default Nav
